import { asArray } from '@bestadapted/utility';
import { useLayoutEffect, useRef, useState } from 'react';
export var toBase64 = function (value) {
    if (value === void 0) { value = ''; }
    return btoa(value);
};
export var fromBase64 = function (value) {
    if (value === void 0) { value = ''; }
    return atob(value);
};
var device = {
    isDesktop: function () {
        return matchMedia ? matchMedia('(min-width: 1281px)').matches : true;
    },
    isDesktopGrid: function () {
        return matchMedia ? matchMedia('(min-width: 840px)').matches : true;
    },
    isTabletGrid: function () {
        return matchMedia ? matchMedia('(min-width: 600px) and (max-width: 839px)').matches : true;
    },
    isLaptop: function () {
        return matchMedia ? matchMedia('(min-width: 1025px) and (max-width: 1280px)').matches : true;
    },
    isTabletIPadPortrait: function () {
        return matchMedia
            ? matchMedia('(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)').matches
            : true;
    },
    isTabletIPadLandscape: function () {
        return matchMedia
            ? matchMedia('(min-width: 768px) and (max-width: 1024px) and (orientation: landscape)').matches
            : true;
    },
    isPhoneLandscape: function () {
        return matchMedia ? matchMedia('(min-width: 480px) and (max-width: 767px)').matches : true;
    },
    isPhone: function () {
        return matchMedia ? matchMedia('(max-width: 599px)').matches : true;
    }
};
export var getViewport = function () { return ({
    isDesktop: device.isDesktop(),
    isDesktopGrid: device.isDesktopGrid(),
    isLaptop: device.isLaptop(),
    isTabletGrid: device.isTabletGrid(),
    isTabletIPadPortrait: device.isTabletIPadPortrait(),
    isTabletIPadLandscape: device.isTabletIPadLandscape(),
    isPhoneLandscape: device.isPhoneLandscape(),
    isPhone: device.isPhone()
}); };
export var initViewport = function () { return ({
    isDesktop: true,
    isDesktopGrid: true,
    isLaptop: false,
    isTabletGrid: false,
    isTabletIPadPortrait: false,
    isTabletIPadLandscape: false,
    isPhoneLandscape: false,
    isPhone: false
}); };
export var getDimensions = function (ref) {
    var _a, _b;
    return ((_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect) === null || _b === void 0 ? void 0 : _b.call(_a)) ||
        (function () { return ({
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }); });
};
export var useDimensions = function (_a) {
    var _b = (_a === void 0 ? {} : _a).on, on = _b === void 0 ? true : _b;
    var ref = useRef();
    var _c = useState({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }), dimension = _c[0], setDimension = _c[1];
    var dimensionRef = useRef(dimension);
    var ro = useState(function () {
        return new ResizeObserver(function () {
            var _a, _b, _c, _d;
            if ((ref === null || ref === void 0 ? void 0 : ref.current) &&
                ((dimensionRef === null || dimensionRef === void 0 ? void 0 : dimensionRef.current.height) !== ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) ||
                    (dimensionRef === null || dimensionRef === void 0 ? void 0 : dimensionRef.current.width) !== ((_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) ||
                    (dimensionRef === null || dimensionRef === void 0 ? void 0 : dimensionRef.current.left) !== ((_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.offsetLeft) ||
                    (dimensionRef === null || dimensionRef === void 0 ? void 0 : dimensionRef.current.top) !== ((_d = ref === null || ref === void 0 ? void 0 : ref.current) === null || _d === void 0 ? void 0 : _d.offsetTop))) {
                var dim = getDimensions(ref);
                dimensionRef.current.height = dim.height;
                dimensionRef.current.width = dim.width;
                dimensionRef.current.left = dim.left;
                dimensionRef.current.top = dim.top;
                setDimension(dim);
            }
        });
    })[0];
    useLayoutEffect(function () {
        if (on && ref.current) {
            setDimension(getDimensions(ref));
            ro.observe(ref.current, {});
        }
        return function () { return ro.disconnect(); };
    }, [on, ref.current]);
    return [ref, dimension];
};
export var withRoot = function (path) { return "" + process.env.PUBLIC_URL + path; };
export var getHeight = function (ref) {
    return ref.current ? ref.current.getBoundingClientRect().height : 0;
};
export var getOffsetTops = function (refs) {
    var dimensions = [];
    asArray(refs).forEach(function (ref) {
        var top = ref.current ? ref.current.offsetTop - ref.current.offsetHeight : 0;
        dimensions.push(top);
    });
    return dimensions;
};
export var scrollTo = function (top) {
    window.scrollTo({
        top: top,
        behavior: 'smooth'
    });
};
export var scrollToTop = function (refs) {
    var tops = getOffsetTops(refs).sort();
    if ((tops === null || tops === void 0 ? void 0 : tops.length) > 0)
        scrollTo(tops[0]);
};
//# sourceMappingURL=util.js.map